// extracted by mini-css-extract-plugin
module.exports = {"image":"speaker-module--image--Y17Nx","eventTitle":"speaker-module--eventTitle--1nAOj","eventTeaser":"speaker-module--eventTeaser--1H3it"};